
<div class="pill" (click)="onDismiss( $event )" [ngClass]="background">
    <span class="pill-text">
    {{text}}
</span>
    <span class="pill-icon">
        <fa-icon [icon]="faTimes"></fa-icon>
    </span>
</div>